import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerForm from '../containers/PlannerFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_route_edit')} />
          <PlannerForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerEditScreen;

Logger.log('silly', `PlannerEditScreen loaded.`);
